import React, { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

// Testimonials mirror the prototype (.docs Client Platform LINK) and
// next-portal-v2-web's auth-slider content.
const TESTIMONIALS = [
  {
    quote:
      "We're proud to partner with Dash Electric, whose electric fleet supports our mission to reduce environmental impact. Together, we're driving a cleaner, greener future.",
    author: 'Dzikri Ahira',
    role: 'CEO of Remind',
  },
  {
    quote:
      "Dash has been key in delivering tailored logistics for Noovoleum, enabling scalable B2B and B2C pickups. They're an essential partner in expanding used cooking oil recycling across Indonesia.",
    author: 'Olivier Biot',
    role: 'Founder & CTO of Noovoleum',
  },
  {
    quote:
      "We appreciate DASH's reliable service and dedicated courier support that ensures efficient deliveries across Jabodetabek. They're responsive, flexible, and always solution-oriented, making them a trusted logistics partner.",
    author: 'Rendy Mandhadri',
    role: 'Logistic & Inventory Manager at SATURDAYS',
  },
];

const SLIDE_DURATION = 5000;

const AuthCarousel: React.FC = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((i) => (i + 1) % TESTIMONIALS.length);
    }, SLIDE_DURATION);
    return () => clearInterval(timer);
  }, []);

  return (
    <div
      className="relative hidden flex-1 flex-col justify-center overflow-hidden p-14 text-white lg:flex"
      style={{
        background:
          'linear-gradient(150deg, var(--primary-darker), var(--primary-base) 55%, #9B7BF7)',
      }}
    >
      {/* Decorative circles (prototype ::before / ::after) */}
      <div className="pointer-events-none absolute -right-32 -top-32 size-[380px] rounded-full bg-white/[0.08]" />
      <div className="pointer-events-none absolute -bottom-24 -left-16 size-[280px] rounded-full bg-white/[0.06]" />

      <div className="relative z-10 w-full max-w-[460px]">
        {/* Slides — absolutely stacked, cross-fade.
            Height fits the tallest testimonial so the dots never overlap it. */}
        <div className="relative min-h-[380px]">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              aria-hidden={i !== active}
              className={cn(
                'absolute inset-0 transition-all duration-500 ease-out',
                i === active
                  ? 'translate-y-0 opacity-100'
                  : 'pointer-events-none translate-y-2.5 opacity-0'
              )}
            >
              <div
                className="mb-3.5 text-[54px] font-extrabold leading-[0.6] opacity-35"
                style={{ fontFamily: 'Georgia, serif' }}
                aria-hidden
              >
                &ldquo;
              </div>
              <p className="mb-5 text-2xl font-semibold leading-[1.42]">
                {t.quote}
              </p>
              <div className="font-bold">{t.author}</div>
              <div className="mt-0.5 text-[13px] opacity-80">{t.role}</div>
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className="mt-8 flex gap-2">
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              type="button"
              aria-label={`Go to testimonial ${i + 1}`}
              onClick={() => setActive(i)}
              className={cn(
                'h-[9px] rounded-full transition-all duration-300 ease-out',
                i === active
                  ? 'w-[26px] bg-white'
                  : 'w-[9px] bg-white/35 hover:bg-white/60'
              )}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AuthCarousel;
